<template>
<f7-accordion-item class="accordionForm" @accordion:open="openedAccordion=true"
  @accordion:close="openedAccordion=false">
  <f7-accordion-toggle class="accordionToggle accordionTitleInformation boxRequest">
    <b-row class="documentInformationGrid d-flex justify-content-between align-items-center">
      <b-col cols="5">
        <div>
          <span v-if="document.Name === 'DATA_COMPANY_PRO'">KBIS</span>
          <span v-else-if="document.Name === 'DATA_COMPANY_PART'">Avis de situation</span>
          <span v-else-if="document.Name === 'DATA_RIB'">RIB</span>
          <span v-else-if="document.Name === 'DATA_UBO_PRO'">Statuts de la société</span>
          <span v-else-if="document.Name === 'DATA_WRITER'">Pièce d'identité</span>
          <span v-else-if="document.Name === 'DATA_TAXATION_PRO'">Bilan</span>
          <span v-else>{{ $t('doctypes.' + document.Type + '_general') }}</span>
          {{
            /* $t('suppliers.kyc_form.' + document.Name + '._label') */
            /*shareholder !== false ?
            $t('doctypes.' + document.Type + '_general') :
            (
              (seller.LegalRepresentativeFirstname !== '' && seller.LegalRepresentativeLastname !== '') ?
              $t('doctypes.' + document.Type, {legalRepresentative : seller.LegalRepresentativeFirstname + ' ' + seller.LegalRepresentativeLastname}) :
              $t('doctypes.' + document.Type + '_legal_representative')
            )*/
          }}&nbsp;

          <i class="fa-solid fa-circle-small" v-if="document.Status.toString() === '101'" :style="'color:' + getStatusColor(document.Status.toString())"></i>
          <i class="fa-solid fa-circle-small" v-if="document.Status.toString() === '102'" :style="'color:' + getStatusColor(document.Status.toString())"></i>
          <i class="fa-solid fa-circle-small" v-if="document.Status.toString() === '103'" :style="'color:' + getStatusColor(document.Status.toString())"></i>
          <i class="fa-solid fa-check" v-else-if="document.Status.toString() === '104'" :style="'color:' + getStatusColor(document.Status.toString())"></i>
          <i class="fa-solid fa-xmark" v-else-if="document.Status.toString() === '105'" :style="'color:' + getStatusColor(document.Status.toString())"></i>
          <i class="fa-solid fa-xmark" v-else-if="document.Status.toString() === '106'" :style="'color:' + getStatusColor(document.Status.toString())"></i>
          <i class="fa-solid fa-xmark" v-else-if="document.Status.toString() === '15'" :style="'color:' + getStatusColor(document.Status.toString())"></i>
        </div>
      </b-col>
      <b-col class="text-left" cols="3" :class="docstatusclass[document.Status]">
        <i class="" :class="getStatusIcon(document.Status.toString())"></i>
        {{ getStatusLabel(document.Status.toString(), document.Role) }}
      </b-col>
      <b-col class="filesRow">
        <div v-if="fileArray.length !== 0">
          <div v-for="file in fileArray" class="documentInfoFileName">
            <div class="w-100 no-gutter">
              <div v-if="showValidationButtonsLevel2(document.Status)" class="col-4 px-0">
                <b-button class="btn"
                  @click="updateDecisionLevel2($event, document, 'ACCP')">
                  <i class="fa-solid fa-check"></i>
                  {{ $t('common.accpt') }}
                </b-button>
                <b-button class="btn"
                  @click="updateDecisionLevel2($event, document, 'RFSL')">
                  <i class="fa-solid fa-xmark"></i>
                  {{ $t('common.refus') }}
                </b-button>
              </div>
              <div class="mr-2 px-0">
                <span @click="downloadFile(file, $event)">
                  {{ document.Name }}
                </span>
              </div>
              <a href="#" @click="removeFile(file, $event)" v-if="editableStatus.includes('Doc_' + document.Status)">
                <i class="fa-light fa-xmark" style="margin-right: -10px;">close</i>
              </a>
            </div>

          </div>
        </div>
        <!-- Documents où on peut ajouter un fichier : ceux non obtenables par source
            institutionnelle et pour lesquels on autorise une concaténation s'il y en a plus d'un (pas le RIB par ex),
            ou alors si c'est un fichier récupérable par source institutionnelle seulement s'il a des données récupérables en OCR
            et dans ce cas 1 fichier max.
            Dans tous les cas, le document doit être dans un statut éditable -->
        <div v-if="showUploadFile(document)">
          <b-button class="btn showLargeScreenOnly" :class="{uploadedDocumentsList : fileArray.length !== 0}">
            <span class="fileClickButton" @click="openFileSelectionWindow($event)">
              {{ $t('common.add_file') }}
            </span>
          </b-button>
          <div class="btn showSmallScreenOnly" :class="{uploadedDocumentsList : fileArray.length !== 0}"
            style="margin-bottom: 1rem;">
            <span class="fileClickButton" @click="openFileSelectionWindow($event)">
              {{ $t('common.add_file') }}
            </span>
          </div>
        </div>
        <div class="btn" v-if="institutionalSourceableDocuments.includes(document.Type) && !fileArray.length">
          <span class="fileClickButton" @click="callInstitutionalSource($event)">
            {{ $t('suppliers.ask_institut') }}
          </span>
        </div>
        <div ref="accordionSoftOpener" />
      </b-col>
    </b-row>
  </f7-accordion-toggle>
  <input class="item-input hiddenElementAllSize local-file-input"
    ref="fileButton" type="file"
    @change="executeOCR">
  </input>
  <f7-accordion-content class="background-supplier-document-form">
    <div class="container-document-form" v-if="hasOCRdata && editableStatus.includes('Doc_' + document.Status)">
      <b-row v-if="serializeGet.length != 0 && ocrDone">
        <b-col sm="6" class="form-group"
          v-for="value in serializeGet" :key="value.name">
          <form-write-group-label-input
            :inputLabel="$t('businessDocuments.serialize' + document.Type + '.' + value.name)"
            :inputType="value.name === 'TypeIDCard' ? 'listeSelect' : 'text'"
            :specificErrorIndicator="document.Serialize[value.name].Valid === '0'"
            :warningIndicator="controlsConfig === '1' ? showWarningIndicator(value.name, document.Serialize) : false"
            :specificMessage="controlsConfig === '1' ? getAssociatedMessage(document.Serialize[value.name].Description) : ''"
            v-model="document.Serialize[value.name].Value">
            <select v-if="value.name === 'TypeIDCard'" class="form-control" id="sel2" readonly v-model="document.Serialize[value.name]">
              <option value="">{{ $t('businessDocuments.slct_doct_type') }}</option>
              <option :value="$t('ocr.TypeIDCard.National_Identity_Card')">{{$t('businessDocuments.idcard_info.National_Identity_Card')}}</option>
              <option value="Passeport">{{$t('ocr.TypeIDCard.Passport')}}</option>
              <option value="Titre_sejour">{{$t('ocr.TypeIDCard.Titre_sejour')}}</option>
            </select>
          </form-write-group-label-input>
        </b-col>
      </b-row>

      <div class="row justify-content-start">
        <div class="col-md-4 offset-md-8">
          <b-button
            class="btn"
            @click="uploadDocument">
            <i class="fa-light fa-plane"></i>
            {{
              shareholder !== false ?
              $t('suppliers.save_info_button') :
              $t('businessDocuments.validate_document_button')
            }}
          </b-button>
          <br/><br/>
        </div>
      </div>
    </div>
    <div v-else-if="document.Serialize">
      <b-row class="container-document-form">
        <b-col sm="6" class="form-group"
          v-for="(info, index) in document.Serialize" :key="index"
          v-if="showWithDependency(info, document.Serialize) && info.type !== 'file'">
          <template v-if="info.id">
            <div v-if="info.type === 'checkbox'" class="d-flex flex-row mt-4">
              <b-form-checkbox v-model="info.value"
                value="true" unchecked-value="false">
              </b-form-checkbox>
              <label class="mb-0">
                {{ $t('suppliers.kyc_form.' + document.step_label + '.' + info.label) }}
              </label>
            </div>
            <div v-else-if="info.label === 'CreationDate' || info.label === 'DeliveryDate' || info.label === 'BirthDate'">
              <label>{{ $t('suppliers.kyc_form.' + document.step_label + '.' + info.label) }}</label>
              <input v-model="info.value" disabled
                type="date" class="form-control inputAccordionForm">
              </input>
            </div>
            <form-read-group-label-input v-else
              :inputLabel="$t('suppliers.kyc_form.' + document.step_label + '.' + info.label)"
              :inputValue="info.value">
            </form-read-group-label-input>
          </template>
          <template v-else>
            <form-read-group-label-input v-if="document.Type != ''"
              :inputLabel="$t('businessDocuments.serialize.' + document.Type + '.' + index)"
              :inputValue="info">
            </form-read-group-label-input>
            <form-read-group-label-input v-else
              :inputLabel="$t('businessDocuments.serialize.BILAN.' + index)"
              :inputValue="info">
            </form-read-group-label-input>
          </template>
        </b-col>
      </b-row>
    </div>
  </f7-accordion-content>
</f7-accordion-item>
</template>
<script>
import documentSerialize from '@/helpers/documentSerialize.json'
import FormAccordion from '@/components/common/FormAccordion.vue'
import formDropdownLabelInput from '@/components/common/formDropdownLabelInput.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import formReadGroupLabelInput from '@/components/common/formReadGroupLabelInput.vue'
import {errorMessageAlert} from '@/helpers/alert'
import {statusLabel, statusIcon} from '@/helpers/labels'
import rfslCodes from '@/pages/requests/detailPages/businessDocumentDetailPages/data/rsflCodes.json'
import status from '@/helpers/status'

export default {
  name: 'DocumentGeneralInfo',
  props: ['documents', 'document', 'seller', 'shareholder'],
  components: {
    'form-accordion': FormAccordion,
    'form-dropdown-label-input': formDropdownLabelInput,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'form-read-group-label-input': formReadGroupLabelInput
  },
  data () {
    return {
      controlsConfig: '1',
      docstatusclass: {
        '0': '',
        '2': 'documentRefusedStatus',
        '13': 'MoneyRoadcolor'
      },
      fileArray: [],
      fieldsTypeMap: {},
      openedAccordion: false,
      locationTypeFile: '1',
      ocrDone: true,
      serializeGet: [],
      hasOCRdata: true,
      institutionalSourceableDocuments: ['Kbis', 'STATUS'],
      concatenableDocumentList: ['IDCARD', 'PROOF_OF_ADDRESS'],
      editableStatus: [status.DOC_INITIALIZED],
      idShareholder: ''
    }
  },
  created () {
    if (documentSerialize[this.document.Type]) {
      this.serializeGet = documentSerialize[this.document.Type].fields
      console.log('-----', this.serializeGet)
    }
    for (var j = 0; j < this.serializeGet.length; j++) {
      let field = this.serializeGet[j]
      this.fieldsTypeMap[field.name] = field.type
    }
    if (this.document.Serialize &&
      Object.keys(this.document.Serialize).length === 0 &&
      this.document.Status === 0) {
      this.document.Serialize = {}
      for (var i = 0; i < this.serializeGet.length; i++) {
        this.document.Serialize[this.serializeGet[i].name] = {
          Value: '',
          Valid: '',
          Description: ''
        }
      }
      console.log("----------documentSerialize------",this.document.Serialize)
    }
    if (this.document.Name !== '' && this.document.Name !== undefined && this.document.Type !== '') {
      this.fileArray.push({'Name': this.document.Name, 'Content': 'askDatabase'})
    }
    if (this.document.fields) {
      this.document.Serialize = this.document.fields
    }
    if (this.document.Type) {
      switch (this.document.Type) {
        case 'BILAN':
          this.document.step_label = 'DATA_TAXATION_PRO'
          break
        case 'KBIS':
          this.document.step_label = 'DATA_COMPANY_PRO'
          break
        case 'SITUATION_STATEMENT':
          this.document.step_label = 'DATA_COMPANY_PART'
          break
        case 'STATUS':
          this.document.step_label = 'DATA_UBO_PRO'
          break
        case 'IDCARD':
          this.document.step_label = 'DATA_WRITER'
          break
        case 'RIB':
          this.document.step_label = 'DATA_RIB'
          break
        case 'CERT_VIGI':
          this.document.step_label = 'DATA_CERT_VIGI'
          break
        default:
          break
      }
    }
    // this.hasOCRdata = this.document.Type !== 'Status'
  },
  methods: {
    callInstitutionalSource (e) {
      e.stopPropagation()
      let that = this
      this.$f7.showPreloader(this.$i18n.t('loading.asking_instit'))
      let params = {
        Siren: this.seller.Siren,
        IdDocument: this.document.IdDocument,
        DocType: this.document.Type
      }
      this.$engine.services.suppliers.getDocumentFromInstitutionalSource(params)
      .then(response => {
        if (response.status === 200) {
          this.$f7.hidePreloader()
          this.fileArray.push({'Name': response.data.DocumentName, 'Content': response.data.DocumentData})
          this.document.Status = '13'
          if (!this.openedAccordion) {
            this.$refs.accordionSoftOpener.click()
          }
        }
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    downloadFile (file, e) {
      e.stopPropagation()
      this.$f7.showPreloader(this.$i18n.t('common.dwnldng_fl'))
      let downloadLink = document.createElement('a')
      downloadLink.download = file.Name
      let fileContent = file.Content
      if (fileContent === 'askDatabase') {
        this.$engine.services.businessDocuments.getDocumentDetails(this.document.IdDocument)
        .then(response => {
          if (response.status === 200) {
            this.$f7.hidePreloader()
            downloadLink.href = response.data.Documents[0].Data
            downloadLink.click()
          }
        })
        .catch(error => {
          errorMessageAlert(error, this)
        })
      } else {
        downloadLink.href = fileContent
        this.$f7.hidePreloader()
        downloadLink.click()
      }
    },
    // Load file from browser and start OCR, if current parameters allow it
    executeOCR (e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) { return }
      if (files[0].size <= 2000000) {
        var reader = new FileReader()
        var filename = files[0].name
        reader.onload = (event) => {
          this.fileArray.push({'Name': filename, 'Content': event.target.result})
          if (!documentSerialize[this.document.Type].ocr || this.fileArray.length > 1) {
            console.log('OCR features are currently under maintenance. Please come again later.')
          } else {
            this.ocrDone = false
            this.$f7.showPreloader(this.$i18n.t('sent.ocr_loading', {request_type: this.$i18n.t('servicesNames.business_doc_sing')}))
            let jsonOfOCRdata = {}
            if (this.document.Type === 'RIB') {
              jsonOfOCRdata = { Name: this.seller.SocialReason }
            } else if (this.document.Type === 'IDCARD' || this.document.Type === 'PROOF_OF_ADDRESS') {
              if (this.shareholder !== false) {
                jsonOfOCRdata = { Name: this.shareholder.LastName + ' ' + this.shareholder.FirstName }
              } else if (this.seller.LegalRepresentativeLastname !== '') {
                jsonOfOCRdata = { Name: this.seller.LegalRepresentativeLastname + ' ' + this.seller.LegalRepresentativeFirstname }
              }
            } else if (this.document.Type === 'KBIS') {
              jsonOfOCRdata = { Name: this.seller.SocialReason, Siren: this.seller.Siren }
            }
            return this.$engine.ocr.ocrRequest(
              this.$engine.user.get().id,
              '',
              event.target.result,
              'pdf',
              'scan',
              this.document.Type.toUpperCase(),
              jsonOfOCRdata
            ).then(response => {
              this.$f7.hidePreloader()
              this.$f7.modal({
                title: this.$i18n.t('sent.ocr_end'),
                text: '<span class="preloader"></span>'
              })
              this.$f7.hidePreloader()
              this.$f7.closeModal()
              response = response.data.ControlsInformations
              let attributes = Object.keys(response)
              for (var i = 0; i < attributes.length; i++) {
                this.document.Serialize[attributes[i]] = response[attributes[i]]
                if (attributes[i] === 'TypeIDCard' && response[attributes[i]] !== '' && response[attributes[i]].Value !== '') {
                  this.document.Serialize[attributes[i]] = this.$i18n.t('businessDocuments.idcard_info.' + response[attributes[i]].Value.replace(/\s/g, '_'))
                }
                if (attributes[i] === 'Nationality' && response[attributes[i]] !== '' && response[attributes[i]].Value !== '') {
                  this.document.Serialize[attributes[i]].Value = this.$i18n.t('businessDocuments.nationalities.' + response[attributes[i]].Value)
                }
              }
              this.ocrDone = true
              if (!this.openedAccordion) {
                this.$refs.accordionSoftOpener.click()
              }
            })
            .catch(err => {
              for (var i = 0; i < this.serializeGet.length; i++) {
                this.document.Serialize[this.serializeGet[i].name] = {
                  Value: '',
                  Valid: '0',
                  Description: 'Data not found'
                }
              }
              this.ocrDone = true
              this.$f7.hidePreloader()
              this.$f7.closeModal()
              this.$f7.alert(this.$i18n.t('errors.too_important_tilt') + ' ' + err)
              console.log(this.$i18n.t('errors.too_important_tilt') + ' ' + err)
            })
          }
        }
        reader.readAsDataURL(files[0])
      } else {
        this.$f7.alert(this.$i18n.t('creation_forms.file_size') + Math.round(files[0].size / 1000) + this.$i18n.t('creation_forms.max_file_size') + '2000 Kb',
          this.$i18n.t('creation_forms.max_size_title'))
      }
      this.$refs.fileButton.value = ''
    },
    getAssociatedMessage (errorMessage) {
      if (errorMessage == null) {
        return ''
      }
      if (errorMessage === 'Firstname and lastname are not consistency' || errorMessage === 'Name is not consistency') {
        return this.$i18n.t('errors.OCR_not_known_names_firstnames')
      }
      if (errorMessage === 'Name is close') {
        return this.$i18n.t('errors.OCR_almost_known_names_firstnames')
      }
      let parsedError = errorMessage.replace(/\s/g, '_')
      if (this.$i18n.t('errors.' + parsedError) !== 'errors.' + parsedError) {
        return this.$i18n.t('errors.' + parsedError)
      }
      return this.$i18n.t('errors.Data_format_invalid')
    },
    getLabelColorClass (status) {
      if (status.toString() === '13' || status.toString() === '16' || status.toString() === '103' || status.toString() === '104') {
        return 'MoneyRoadcolorOK'
      } else if (status.toString() === '12' || status.toString() === '14' || status.toString() === '105' || status.toString() === '106') {
        return 'MoneyRoadcolorKO'
      } else {
        return ''
      }
    },
    getStatusColor (status) {
      switch (status) {
        case '101':
          return 'grey'
        case '102':
          return 'deepskyblue'
        case '103':
          return 'orange'
        case '104':
          return 'green'
        case '105':
          return 'red'
        case '15':
        case '106':
          return 'orangered'
        default:
          return 'grey'
      }
    },
    getStatusIcon (status) {
      return statusIcon('Doc_' + status)
    },
    getStatusLabel (status, role) {
      return statusLabel(this.$i18n, 'Doc_' + status, role, -1, -1, this.$engine.user.get())
    },
    openFileSelectionWindow (e) {
      e.stopPropagation()
      this.$refs.fileButton.click()
    },
    removeFile (file, e) {
      e.stopPropagation()
      let index = this.fileArray.indexOf(file)
      this.fileArray.splice(index, 1)
      // deleting OCR results if fileArray is empty
      if (!this.fileArray.length) {
        this.document.Serialize = {}
        for (var i = 0; i < this.serializeGet.length; i++) {
          this.document.Serialize[this.serializeGet[i].name] = {}
        }
      }
    },
    sendDecisionUpdateLevel2 (document, action, decisionMessage = '') {
      let that = this
      let paramsToSend = {
        Receiver: this.$engine.user.get().identifier,
        AttachmentId: document.DocumentIdentifier,
        AttachmentName: document.Name,
        TransactionStatus: action,
        DecisionMessage: decisionMessage,
        IdDocument: document.IdDocument
      }
      this.$engine.services.businessDocuments.updateDocument(paramsToSend)
      .then(response => {
        that.status = response.status
        if (response.status === 200) {
          that.$f7.hidePreloader()
          that.$f7.modal({
            title: this.$i18n.t('businessDocuments.updated_doc'),
            text: '<span class="preloader"></span>'
          })
          if (action === 'ACCP') {
            this.document.Status = '16'
          } else if (action === 'RFSL') {
            this.document.Status = '14'
          }
          setTimeout(function () {
            that.$f7.closeModal()
          }, 2000)
        }
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    showUploadFile (document) {
      if (((!this.institutionalSourceableDocuments.includes(document.Type) &&
          (!this.fileArray.length || this.concatenableDocumentList.includes(document.Type))) ||
          (this.hasOCRdata && !this.fileArray.length)) &&
          this.editableStatus.includes('Doc_' + document.Status)) {
        return true
      }
      return false
    },
    showValidationButtonsLevel2 (documentStatus) {
      return documentStatus === 13
    },
    showWarningIndicator (valueName, serializedDoc) {
      if (valueName === 'Name') {
        return parseInt(serializedDoc[valueName].Score) >= 201 && parseInt(serializedDoc[valueName].Score) <= 399
      }
      return false
    },
    showWithDependency (field, fields) {
      if (field.dependency) {
        let dependenciesBool
        let dependenciesIdOR = []
        let dependenciesIdAND = []
        let dependenciesValueOR = []
        let dependenciesValueAND = []
        if (field.dependency.id.includes('|')) {
          dependenciesBool = false
          dependenciesIdOR = field.dependency.id.split('|')
          dependenciesValueOR = field.dependency.value.split('|')
        } else if (field.dependency.id.includes('&')) {
          dependenciesBool = true
          dependenciesIdAND = field.dependency.id.split('&')
          dependenciesValueAND = field.dependency.value.split('&')
        }
        for (let indexFieldToCheck in fields) {
          let fieldToCheck = fields[indexFieldToCheck]
          if (fieldToCheck.id === field.dependency.id) {
            if (field.dependency.operator) {
              switch (field.dependency.operator) {
                case '!':
                  return fieldToCheck.value !== field.dependency.value
                case '<':
                  return parseFloat(fieldToCheck.value) < parseFloat(field.dependency.value)
                case '>':
                  return parseFloat(fieldToCheck.value) > parseFloat(field.dependency.value)
                default:
                  if (field.dependency.value.includes('|')) {
                    return field.dependency.value.split('|').includes(fieldToCheck.value)
                  }
                  return fieldToCheck.value === field.dependency.value
              }
            }
            return fieldToCheck.value === field.dependency.value
          } else if (dependenciesIdOR.length && dependenciesIdOR.includes(fieldToCheck.id)) {
            let idDependencies = dependenciesIdOR.indexOf(fieldToCheck.id)
            dependenciesBool = dependenciesBool || fieldToCheck.value === dependenciesValueOR[idDependencies]
          } else if (dependenciesIdAND.length && dependenciesIdAND.includes(fieldToCheck.id)) {
            let idDependencies = dependenciesIdAND.indexOf(fieldToCheck.id)
            dependenciesBool = dependenciesBool && fieldToCheck.value === dependenciesValueAND[idDependencies]
          }
        }
        if (dependenciesIdOR.length || dependenciesIdAND.length) {
          return dependenciesBool
        }
      }
      return true
    },
    updateDecisionLevel2 (e, document, action) {
      e.stopPropagation()
      let that = this
      let options = ''
      let type = document.Type
      let rfslCodesType = rfslCodes[type]
      let modalText = ''

      for (let id in rfslCodesType) {
        let label = that.$i18n.t('common.rfsl.' + type + '.s_' + rfslCodesType[id])
        let value = that.$i18n.t('common.rfsl.' + type + '.l_' + rfslCodesType[id])
        options += '<option value="' + value + '">' + label + '</option>'
      }

      if (action === 'RFSL') {
        modalText = '<div>' +
                      '<span>Sélectionner un motif de refus :</span>' +
                      '<select id="selectCodeRefus" style="width:200px;">' +
                        options +
                      '</select>' +
                    '</div>'
      }

      that.$f7.modal({
        title: action === 'RFSL' ? that.$i18n.t('businessDocuments.refuse_doc_confirmation') : that.$i18n.t('businessDocuments.accept_doc_confirmation'),
        text: modalText,
        buttons: [
          {
            text: that.$i18n.t('common.cncl'),
            onClick: function () {}
          },
          {
            text: action === 'RFSL' ? that.$i18n.t('common.refus') : that.$i18n.t('common.accpt'),
            onClick: function () {
              that.sendDecisionUpdateLevel2(document, action, that.Dom7('#selectCodeRefus').val())
            }
          }
        ]
      })
    },
    uploadDocument () {
      // Only filearray is empty for whatever document
      if (!this.fileArray.length) {
        this.$f7.alert(this.$i18n.t('errors.please_insert_file'), this.$i18n.t('errors.missing_file'))
        return
      }

      if (this.shareholder.FirstName === '' || this.shareholder.LastName === '') {
        this.$f7.alert(this.$i18n.t('errors.shareholders_name_mandatory'), this.$i18n.t('errors.errors_in_form'))
        return
      }
      if (parseInt(this.shareholder.PercentageDetention) < 25) {
        this.$f7.alert(this.$i18n.t('errors.percentage_detention_too_low'), this.$i18n.t('errors.errors_in_form'))
        return
      }

      let documentInformations = {}
      let attributes = Object.keys(this.document.Serialize)
      for (var j = 0; j < attributes.length; j++) {
        if (typeof this.document.Serialize[attributes[j]] === 'object') {
          documentInformations[attributes[j]] = this.document.Serialize[attributes[j]].Value
        } else {
          documentInformations[attributes[j]] = this.document.Serialize[attributes[j]]
        }
      }
      this.$f7.showPreloader(this.$i18n.t('loading.sending_document_UBO'))
      let fileContentToSend = this.fileArray[0].Content
      if (this.fileArray.length > 1) {
        for (let i = 1; i < this.fileArray.length; i++) {
          fileContentToSend += ';' + this.fileArray[i].Content.substring(this.fileArray[i].Content.indexOf(',') + 1)
        }
      }
      let that = this
      if (this.shareholder !== false && this.shareholder.IdUBO === undefined && that.idShareholder === '') {
        // Adding UBO if it is a new id
        that.$engine.services.suppliers.addUBO({
          Siren: that.seller.Siren,
          IdExchangeGroup: that.seller.IdGroupDocument,
          UBO: {
            LastName: that.shareholder.LastName,
            FirstName: that.shareholder.FirstName,
            PercentageDetention: that.shareholder.PercentageDetention,
            IsLegalRepresentative: that.shareholder.IsLegalRepresentative
          }
        })
        .then(response => {
          if (response.status === 200 || response.status === 201) {
            that.idShareholder = response.data.IdUBO
            that.$engine.services.suppliers.uploadDocument({
              IdDocument: that.document.Type === 'IDCARD' ? response.data.IdDocumentBeneficialCNI : response.data.IdDocumentBeneficialProofOfAddress,
              IdSeller: that.seller.IdSeller,
              DocumentType: that.document.Type,
              DocumentName: that.fileArray[0].Name,
              ocr: '1',
              DocumentData: fileContentToSend,
              Serialize: documentInformations
            })
            .then(response => {
              that.status = response.status
              if (response.status === 200) {
                that.$f7.hidePreloader()
                that.$f7.modal({
                  title: that.$i18n.t('success.UBO_added_document_sent'),
                  text: '<i class="fa-solid fa-check"></i>'
                })
                this.document.Status = '11'
                let attributes = Object.keys(this.document.Serialize)
                for (var j = 0; j < attributes.length; j++) {
                  if (typeof this.document.Serialize[attributes[j]] === 'object') {
                    this.document.Serialize[attributes[j]] = this.document.Serialize[attributes[j]].Value
                  }
                }
                this.fileArray = [{'Name': response.data.DocumentName, 'Content': response.data.DocumentData}]
                setTimeout(function () {
                  that.$f7.closeModal()
                }, 2000)
              }
            })
            .catch(error => {
              errorMessageAlert(error, that)
            })
          }
        })
        .catch(error => {
          errorMessageAlert(error, that)
        })
      } else {
        that.$engine.services.suppliers.uploadDocument({
          IdDocument: that.document.IdDocument,
          IdSeller: that.seller.IdSeller,
          DocumentType: that.document.Type,
          DocumentName: that.fileArray[0].Name,
          ocr: '1',
          DocumentData: fileContentToSend,
          Serialize: documentInformations
        })
        .then(response => {
          that.status = response.status
          if (response.status === 200) {
            that.$f7.hidePreloader()
            that.$f7.modal({
              title: that.$i18n.t('success.document_sent'),
              text: '<i class="fa-solid fa-check"></i>'
            })
            this.document.Status = '11'
            let attributes = Object.keys(this.document.Serialize)
            for (var j = 0; j < attributes.length; j++) {
              if (typeof this.document.Serialize[attributes[j]] === 'object') {
                this.document.Serialize[attributes[j]] = this.document.Serialize[attributes[j]].Value
              }
            }
            this.fileArray = [{'Name': response.data.DocumentName, 'Content': response.data.DocumentData}]
            setTimeout(function () {
              that.$f7.closeModal()
            }, 2000)
          }
        })
        .catch(error => {
          errorMessageAlert(error, that)
        })
      }
    }
  }
}
</script>
<style scoped>
.documentRefusedStatus {
  color: red;
  font-weight: bold;
}

.documentInfoFileName {
  cursor: pointer;
}

.filesRow {
  text-decoration: underline;
}

@media (max-width: 992px) {
  .documentInfoAlignRight {
    text-align: left;
  }

  .filesRow {
    grid-column-start: 1;
    grid-column-end: 3;
  }
}
@media (min-width: 993px) {
  .documentInfoFileName {
    text-align: right;
  }
  .importFileButton {
    text-align: right;
  }
}

.uploadedDocumentsList {
  margin-top: 15px;
}

.iconTab {
  margin-left: 6px;
  margin-top: 2px;
  position: absolute;
  height: 8px;
  width: 8px;
}

.dot {
  background-color: grey;
  border-radius: 50%;
  margin-left: 8px;
  margin-top: 8px;
  position: absolute;
  height: 8px;
  width: 8px;
}

</style>
